import { storage } from '@/firebase/init'
import { getMetadata, ref } from 'firebase/storage'

export async function getStorageHead({
  path,
}: {
  path: string
}): Promise<void> {
  const fileRef = ref(storage, path)

  try {
    await getMetadata(fileRef)
  } catch (err: unknown) {
    // Preserve specific "not found" semantics while allowing other errors to propagate.
    if (
      err &&
      typeof err === 'object' &&
      'code' in err &&
      (err as { code?: string }).code === 'storage/object-not-found'
    ) {
      throw new Error('file-not-found')
    }
    throw err
  }
}
